<template>

  <v-menu
    offset-y
    close-on-click
    close-on-content-click
    transition="scroll-y-transition"
    origin="center center"
    :disabled="items.length == 0"
  >
    <template v-slot:activator="{ on: menu, attrs }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            color="primary"
            v-bind="attrs"
            :loading="isLoading"
            v-on="{ ...tooltip, ...menu }"
            style="width: 100%"
          >
            {{ licenseNumber }}
          </v-btn>
        </template>
        <span>Metrc License: {{ displayName }}</span>
      </v-tooltip>
    </template>

    <v-list dense shaped>
      <v-list-item-group v-model="selectedItem" color="primary">
        <v-list-item v-for="(item, i) in revisedItems" :key="i">
          <v-list-item-title>{{ item.DisplayName }}</v-list-item-title>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
import Metrc from "@/plugins/servers/metrc.js";
import moment from "moment";
import { EventBus } from "@/event-bus.js";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "",
  props: ["value"],

  components: {},

  beforeMount() {
    this.licenseNumber = localStorage.getItem("metrcLicense");
    this.refresh().then(() => {
      if (localStorage.getItem("metrcLicense")) {
        this.licenseNumber = localStorage.getItem("metrcLicense");
      } else if (this.defaultLicense) {
        this.licenseNumber = this.defaultLicense.LicenseNumber;
      } else {
        this.licenseNumber = this.value;
      }
    })
  },
  mounted() {},
  data() {
    return {
      selectedItem: null,
      licenseNumber: null,
      displayName: "",
      items: [],
      isLoading: false,
      revisedItems: []
    };
  },

  computed: {
    ...mapGetters(["getUser"]),
  },
  watch: {
    selectedItem(newVal, oldVal) {
      if (this.revisedItems && this.revisedItems.length > 0) {
        this.licenseNumber = this.revisedItems[newVal].LicenseNumber;
        this.displayName = this.revisedItems[newVal].DisplayName;
      }
    },
    licenseNumber(newVal, oldVal) {
      if (newVal != "undefined") {
        localStorage.setItem("metrcLicense", newVal);
        this.$emit("input", newVal);
        EventBus.$emit("metrclicensechange", newVal);
      }
    },
  },
  methods: {

    refresh() {
      let me = this;
      me.isLoading = true;

      if (!this.getUser || !this.getUser.facility || !this.getUser.facility.state) {
        setTimeout(this.refresh,250);
        return;
      }

      return Metrc.get("Facilities", {
        filter: {
          where : {
            facility_id : this.getUser.facility_id
          }
        }
      }).then(function ([res, err]) {

        me.isLoading = false;

        for (let i=0; i<res.length; i++) {
          res[i].DisplayName = res[i].DisplayName + '-' + res[i].LicenseType + ' : ' + res[i].LicenseNumber;
        }
        me.items = res;
        me.defaultLicense = me.items.find(license => license.isDefault);
        window.localStorage.setItem("metrcLicenses", JSON.stringify(me.items));
        me.revisedItems = res;

        if ((typeof me.licenseNumber === "undefined" || me.licenseNumber === null) && !me.defaultLicense) {
          me.selectedItem = 0;
        } else if (typeof me.licenseNumber === "undefined" || me.licenseNumber === null) {
          for (let i = 0; i < me.revisedItems.length; i++) {
            if (me.revisedItems[i].LicenseNumber === me.defaultLicense.LicenseNumber) {
              me.selectedItem = i;
            }
          }
        } else {
          for (let i = 0; i < me.revisedItems.length; i++) {
            if (me.revisedItems[i].LicenseNumber == me.licenseNumber) {
              me.selectedItem = i;
            }
          }
        }

      });
    },
  },
};
</script>
<style>
</style>

